import { useQuery } from 'react-query';
import { RemoteSearchRepo } from '@repository/serch/SearchRepo';
import CompanyVO from '@domain/vo/search/CompanyVO';

export const keys = ['search', 'company', 'list'];

const remoteSearchRepo = new RemoteSearchRepo();

const fetchSearchCompanyList = async (keyword: string) => {
  const { data } = await remoteSearchRepo.fetchSearchCompanyList(keyword);
  return data.companies.map((item) => new CompanyVO(item));
};

export default function useCompanyList(keyword: string) {
  return useQuery([...keys, keyword], () => fetchSearchCompanyList(keyword), {
    initialData: [],
  });
}
